import * as React from 'react';
import styled from 'styled-components';
import COLOR from 'constants/color';

interface CheckboxProps {
  children?: React.ReactNode;
  onClick: (e: React.MouseEvent) => void;
  selected?: boolean;
  disabled?: boolean;
}

const Checkbox = (props: CheckboxProps): JSX.Element => (
  <Container
    disabled={props.disabled}
    onClick={props.disabled ? null : props.onClick}
  >
    <CheckboxContainer disabled={props.disabled}>
      {
        props.selected ? (
          <SelectedContainer />
        ) : false
      }
    </CheckboxContainer>
    {
      props.children ? (
        <TextContainer>
          {props.children}
        </TextContainer>
      ) : false
    }
  </Container>
);

const Container = styled.div<{ disabled?: boolean }>`
  align-items: center;
  display: flex;
  cursor: ${(props): string => props.disabled ? 'default' : 'pointer'};
`;

const CheckboxContainer = styled.div<{ disabled?: boolean }>`
  background-color: ${(props): string => props.disabled ? COLOR.neutral : COLOR.white};
  border: 1px solid ${(props): string => props.disabled ? COLOR.midDarkGrey : COLOR.midLightGrey};
  border-radius: 4px;
  cursor: ${(props): string => props.disabled ? 'default' : 'pointer'};
  height: 1rem;
  width: 1rem;
  min-width: 1rem;
  z-index: 10;
`;

const SelectedContainer = styled.div`
  background-color: ${COLOR.blue};
  height: 0.625rem;
  margin: 0.1825rem;
  width: 0.625rem;
`;

const TextContainer = styled.div`
  margin-left: 0.5rem;
`;

export default Checkbox;